import React from 'react';

import { useLoyaltyOffersUiLoggedOutQuery } from 'generated/sanity-graphql';
import { maybeLocaleString } from 'utils/graphql';

import { Body, Container, StyledButton, Title } from './loyalty-end-of-offers-logged-out.styled';

export const LoyaltyEndOfOffersLoggedOut = () => {
  const { data } = useLoyaltyOffersUiLoggedOutQuery({
    variables: {
      id: 'feature-loyalty-offers-ui-singleton',
    },
  });

  const endOfOffersLoggedOut = data?.LoyaltyOffersUI?.endOfOffersLoggedOut;
  const title = maybeLocaleString(endOfOffersLoggedOut?.title);
  const body = maybeLocaleString(endOfOffersLoggedOut?.body);
  const buttonText = maybeLocaleString(endOfOffersLoggedOut?.ctaButtonText);
  const buttonLink = maybeLocaleString(endOfOffersLoggedOut?.link);

  return title ? (
    <Container>
      <Title>{title}</Title>
      {body && <Body>{body}</Body>}
      {buttonText && buttonLink && <StyledButton to={buttonLink}>{buttonText}</StyledButton>}
    </Container>
  ) : null;
};
